/**
 * SCC (Station Command Center) link configuration.
 * Maps country codes to their respective SCC base URLs for tracking ID lookups.
 *
 * Usage: buildSccLink(trackingId, country)
 * Example: buildSccLink("TBA333098170438", "US")
 *   → "https://logistics.amazon.com/station/dashboard/search?shareableLink=detailPage%2FTBA333098170438"
 *
 * Region mapping:
 *   NA (US, CA, MX) → logistics.amazon.com
 *   EU (GB, DE, FR, IT, ES, NL, PL, SE, IN, TR, AE, SA, EG, ZA, BE) → logistics.amazon.co.uk
 *   FE-JP → logistics.amazon.co.jp
 *   FE-AU → logistics.amazon.com.au
 *   BR → logistics.amazon.com.br
 */

const SCC_DOMAINS: Record<string, string> = {
    NA: 'https://logistics.amazon.com/station/dashboard/search',
    EU: 'https://logistics.amazon.co.uk/station/dashboard/search',
    JP: 'https://logistics.amazon.co.jp/station/dashboard/search',
    AU: 'https://logistics.amazon.com.au/station/dashboard/search',
    BR: 'https://logistics.amazon.com.br/station/dashboard/search',
    SG: 'https://logistics.amazon.com.sg/station/dashboard/search',
};

const COUNTRY_TO_SCC_REGION: Record<string, string> = {
    // NA
    US: 'NA', CA: 'NA', MX: 'NA',
    // BR
    BR: 'BR',
    // EU
    GB: 'EU', UK: 'EU', DE: 'EU', FR: 'EU', IT: 'EU', ES: 'EU',
    NL: 'EU', PL: 'EU', SE: 'EU', IN: 'EU', TR: 'EU', AE: 'EU',
    SA: 'EU', EG: 'EU', ZA: 'EU', BE: 'EU',
    // FE
    JP: 'JP', AU: 'AU', SG: 'SG',
};

export const getSccBaseUrl = (country: string): string => {
    const region = COUNTRY_TO_SCC_REGION[country] || 'NA';
    return SCC_DOMAINS[region];
};

export const buildSccLink = (trackingId: string, country: string): string => {
    return `${getSccBaseUrl(country)}?shareableLink=detailPage%2F${trackingId}`;
};
